import { IAddUpdateObraRequest } from "../../../../model/admin-portal/request/add-update-obra-request";
import { IObraResponse } from "../../../../model/admin-portal/response/obra-response";
import { ISituacaoObraResponse } from "../../../../model/admin-portal/response/situacao-obra-response";
import { IFuncaoObraResponse } from "../../../../model/admin-portal/response/funcao-obra-response";
import { ITipoObraResponse } from "../../../../model/admin-portal/response/tipo-obra-response";
import { IContratoLookupResponse } from "../../../../model/admin-portal/response/contrato-lookup-response";
import { IConvenioLookupResponse } from "../../../../model/admin-portal/response/convenio-lookup-response";
import { IBasePagedRequest } from "../../../../model/base/request/base-paged-request";
import { PaginationResponse } from "../../../../model/base/response/pagination-response";

// Foto escolhida antes de a Obra existir de fato (sem Id ainda) - fica em
// memória até o "Salvar" da Obra criar o registro e disparar o upload de cada uma.
export interface IPendingFotoObra {
    tempId: string;
    descricao: string;
    dtaPublicacao: string;
    file: File;
}

export type ObrasState = {
    dataPaginatedListResponse: PaginationResponse<IObraResponse>;
    isLoadingData: boolean;
    dataResponse: IObraResponse | null;
    dataRequest: IAddUpdateObraRequest;
    showAddEdit: boolean;
    dataSearchRequest: IBasePagedRequest;
    situacoesList: ISituacaoObraResponse[];
    funcoesList: IFuncaoObraResponse[];
    tiposList: ITipoObraResponse[];
    contratosList: IContratoLookupResponse[];
    conveniosList: IConvenioLookupResponse[];
    pendingFotos: IPendingFotoObra[];
};

export const initialDataRequest: IAddUpdateObraRequest = {
    id: null,
    idContrato: null,
    idConvenio: null,
    idSituacaoObra: null,
    idFuncaoObra: null,
    idTipoObra: null,
    dtaInicio: '',
    dtaPrevisaoConclusao: '',
    dtaConclusao: null,
    valorObra: 0,
    percentualExecutado: null
};

export const initialState: ObrasState = {
    dataPaginatedListResponse: new PaginationResponse<IObraResponse>(),
    isLoadingData: false,
    dataResponse: null,
    dataRequest: initialDataRequest,
    showAddEdit: false,
    dataSearchRequest: { page: 0, pageSize: 10 },
    situacoesList: [],
    funcoesList: [],
    tiposList: [],
    contratosList: [],
    conveniosList: [],
    pendingFotos: []
};

export enum ACTION_TYPES {
    setDataPaginatedListResponse = 'setDataPaginatedListResponse',
    setIsLoadingData = 'setIsLoadingData',
    setDataResponse = 'setDataResponse',
    setDataRequest = 'setDataRequest',
    setShowAddEdit = 'setShowAddEdit',
    setDataSearchRequest = 'setDataSearchRequest',
    setSituacoesList = 'setSituacoesList',
    setFuncoesList = 'setFuncoesList',
    setTiposList = 'setTiposList',
    setContratosList = 'setContratosList',
    setConveniosList = 'setConveniosList',
    setPendingFotos = 'setPendingFotos'
}

type Action =
    | { type: ACTION_TYPES.setDataPaginatedListResponse; payload: PaginationResponse<IObraResponse> }
    | { type: ACTION_TYPES.setIsLoadingData; payload: boolean }
    | { type: ACTION_TYPES.setDataResponse; payload: IObraResponse | null }
    | { type: ACTION_TYPES.setDataRequest; payload: IAddUpdateObraRequest }
    | { type: ACTION_TYPES.setShowAddEdit; payload: boolean }
    | { type: ACTION_TYPES.setDataSearchRequest; payload: IBasePagedRequest }
    | { type: ACTION_TYPES.setSituacoesList; payload: ISituacaoObraResponse[] }
    | { type: ACTION_TYPES.setFuncoesList; payload: IFuncaoObraResponse[] }
    | { type: ACTION_TYPES.setTiposList; payload: ITipoObraResponse[] }
    | { type: ACTION_TYPES.setContratosList; payload: IContratoLookupResponse[] }
    | { type: ACTION_TYPES.setConveniosList; payload: IConvenioLookupResponse[] }
    | { type: ACTION_TYPES.setPendingFotos; payload: IPendingFotoObra[] };

export const obrasReducer = (state: ObrasState, action: Action): ObrasState => {
    switch (action.type) {
        case ACTION_TYPES.setDataPaginatedListResponse:
            return { ...state, dataPaginatedListResponse: action.payload };
        case ACTION_TYPES.setIsLoadingData:
            return { ...state, isLoadingData: action.payload };
        case ACTION_TYPES.setDataResponse:
            return { ...state, dataResponse: action.payload };
        case ACTION_TYPES.setDataRequest:
            return { ...state, dataRequest: action.payload };
        case ACTION_TYPES.setShowAddEdit:
            return { ...state, showAddEdit: action.payload };
        case ACTION_TYPES.setDataSearchRequest:
            return { ...state, dataSearchRequest: action.payload };
        case ACTION_TYPES.setSituacoesList:
            return { ...state, situacoesList: action.payload };
        case ACTION_TYPES.setFuncoesList:
            return { ...state, funcoesList: action.payload };
        case ACTION_TYPES.setTiposList:
            return { ...state, tiposList: action.payload };
        case ACTION_TYPES.setContratosList:
            return { ...state, contratosList: action.payload };
        case ACTION_TYPES.setConveniosList:
            return { ...state, conveniosList: action.payload };
        case ACTION_TYPES.setPendingFotos:
            return { ...state, pendingFotos: action.payload };
        default:
            return state;
    }
};
